/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodSurprised = createReactComponent("outline", "mood-surprised", "IconMoodSurprised", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9l.01 0", "key": "svg-1" }], ["path", { "d": "M15 9l.01 0", "key": "svg-2" }], ["path", { "d": "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }]]);

export { IconMoodSurprised as default };
//# sourceMappingURL=IconMoodSurprised.mjs.map
